var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-[#f4f5f8] m-0 min-h-screen register-main-wrapper"},[_c('div',{staticClass:"text-container"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t("youdonothaveaccess"))+".")]),_c('a',{attrs:{"href":_vm.CABINET_URL}},[_c('button',{staticClass:"btn"},[_vm._v(_vm._s(_vm.$t("backToHome")))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }